import get from 'lodash.get';
import actionTypes from 'yola-editor/src/js/modules/user/constants/action-types';
import operations from '../operations';
import wonderchat from '../wonderchat';
import serviceClient from '../../feature-flags/service-client';
import setHelpCenterIntegration from '../actions/set-help-center-integration';
import integrationTypes from '../constants/integration-types';

const initHelpCenter = (store) => (next) => (action) => {
  const { type, payload } = action;

  next(action);

  if (type !== actionTypes.SET_USER_PARTNER_DATA) {
    return;
  }

  const isWL = get(payload, 'partnerData.isWhiteLabel', true);

  if (!isWL) {
    const featureFlagsManager = serviceClient.get();

    featureFlagsManager.request(['zendesk_widget', 'wonderchat_widget']).then((flags) => {
      const { wonderchat_widget: wonderchatWidget, zendesk_widget: zendeskWidget } = flags;

      if (wonderchatWidget) {
        store.dispatch(setHelpCenterIntegration(integrationTypes.WONDERCHAT));
        wonderchat.initChat();
      } else if (zendeskWidget) {
        store.dispatch(setHelpCenterIntegration(integrationTypes.ZENDESK));
        operations.preload();
      }
    });
  }
};

export default initHelpCenter;
